export const subscriptionStatus = [{
  value: 'Active', label: 'Active', color: 'green'
}, {
  value: 'Cancelled', label: 'Cancelled', color: 'yellow'
}, {
  value: 'Terminated', label: 'Terminated', color: 'red'
}, {
  value: 'Suspended', label: 'Suspended', color: 'gray'
}, {
  value: 'Suspending', label: 'Suspending', color: 'orange'
}];